export default "__VITE_ASSET__d7abdfc4__"